module.exports = __webpack_public_path__ + "static/media/milex-logo-pwa@3x.cfa4619a.jpg";